import { Box, Link, Text } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { HowToSchema, HowToStep } from '@99designs/marketing-ui';
import { useTrackCTALinkClicked } from '../../../lib/events';
import { ProductLandingGroupKey } from '../../../lib/productLandingGroups';
import { removeHTMLTags } from '../../../util/removeHTMLTags';
import HowItWorkOptions from './HowItWorkOptions';

interface ContentProps {
    contestDescription: string;
    pricingLink: string;
    categoryKey: ProductLandingGroupKey;
    pricingOptions: string;
}
export default function HowItWorksContent({
    contestDescription,
    pricingLink,
    categoryKey,
    pricingOptions,
}: ContentProps) {
    const seePricingCTARef = useTrackCTALinkClicked({
        category: categoryKey,
        ctaLocation: 'how it works section',
        ctaButton: `See ${categoryKey} pricing options`,
    });
    const findADesignerCTARef = useTrackCTALinkClicked({
        category: categoryKey,
        ctaLocation: 'how it works section',
        ctaButton: 'Browse designer portfolios',
    });
    const sectionName = __(
        'We offer two amazing ways to work with our community of professional designers.'
    );
    const contestHeading = __('Start a contest with our designer community');
    const hireDesignerHeading = __('Find a designer and start a 1-to-1 project');
    const hireDesignerDescription = __(
        'No matter your business needs, we’ve got an expert you can work with to bring your design to life.'
    );

    const stepsForSchema: HowToStep[] = [
        {
            name: contestHeading,
            description: removeHTMLTags(contestDescription),
        },
        {
            name: hireDesignerHeading,
            description: removeHTMLTags(hireDesignerDescription),
        },
    ];

    return (
        <Box maxWidth={['fit-content', 'fit-content', '450px', '500px']}>
            <HowToSchema name={sectionName} steps={stepsForSchema} />
            <Text size="size4">{sectionName}</Text>
            <Box>
                <Box display="flex" flexDirection={['column', 'row', 'column', 'column']}>
                    <HowItWorkOptions
                        badgeColor={colors.littlePiggy}
                        badgeValue={1}
                        contentHeading={contestHeading}
                        contentDescription={
                            <>
                                {contestDescription}
                                &nbsp;
                                <Link href={pricingLink} target="_blank" ref={seePricingCTARef}>
                                    {pricingOptions}
                                </Link>
                            </>
                        }
                    />
                    <HowItWorkOptions
                        badgeColor={colors.mildredsCar}
                        badgeValue={2}
                        contentHeading={hireDesignerHeading}
                        contentDescription={
                            <>
                                {hireDesignerDescription}
                                &nbsp;
                                <Link
                                    href={`/designers/search?categories[]=${categoryKey}`}
                                    target="_blank"
                                    ref={findADesignerCTARef}
                                >
                                    {__('Browse designer portfolios.')}
                                </Link>
                            </>
                        }
                    />
                </Box>
            </Box>
        </Box>
    );
}
